import {
  Button,
  TextField,
  Box,
  Typography,
  CircularProgress,
} from '@mui/material'
import PageAppBar from 'components/PageAppBar'
import { base_url } from 'env'
import { useState } from 'react'
import { useNavigate } from 'react-router'
import axios from 'axios'

interface MilestoneCreate {
  value: number
  title: string
}

const initialMilestone: MilestoneCreate = {
  value: 0,
  title: '',
}

export default function MilestoneCreatePage() {
  const navigate = useNavigate()
  const [milestone, setMilestone] = useState(initialMilestone)
  const [isSaving, setIsSaving] = useState(false)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target
    setMilestone((prev) => ({
      ...prev,
      [name]: name === 'value' ? Number(value) : value,
    }))
  }

  const handleSubmit = () => {
    if (!milestone.title || milestone.value < 0) {
      alert('Veuillez remplir tous les champs correctement.')
      return
    }

    setIsSaving(true)
    const token = localStorage.getItem('token')

    axios
      .post(base_url + `/milestone/`, milestone, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        alert('Jalon créé avec succès !')
        navigate('/milestones')
      })
      .catch((error) => {
        console.error('Failed to create milestone:', error)
        alert('La création a échoué: ' + error.response?.data?.message)
      })
      .finally(() => {
        setIsSaving(false)
      })
  }

  return (
    <PageAppBar pageName="Créer un Jalon">
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          alignItems: 'center',
          padding: '2rem',
          maxWidth: '600px',
          margin: '0 auto',
        }}
      >
        <Typography variant="h5">Nouveau Jalon</Typography>
        <TextField
          required
          fullWidth
          name="title"
          label="Titre à décerner"
          value={milestone.title}
          onChange={handleChange}
        />
        <TextField
          required
          fullWidth
          name="value"
          label="Seuil (Points ou Temps total)"
          type="number"
          value={milestone.value}
          onChange={handleChange}
          inputProps={{
            min: 0,
          }}
        />
        <Button
          variant="contained"
          color="success"
          onClick={handleSubmit}
          disabled={isSaving}
          sx={{ mt: 2 }}
        >
          {isSaving ? <CircularProgress size={24} /> : 'Créer le jalon'}
        </Button>
      </Box>
    </PageAppBar>
  )
}
